import { render, staticRenderFns } from "./DeviceEventView.vue?vue&type=template&id=45b6a43f&lang=html"
import script from "./DeviceEventView.vue?vue&type=script&lang=js"
export * from "./DeviceEventView.vue?vue&type=script&lang=js"
import style0 from "./DeviceEventView.vue?vue&type=style&index=0&id=45b6a43f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports